import { createContext, useEffect, useState } from "react";
import seasonalService from "../service/seasonalService";
import { withRusticMediaVersion } from "../utils/mediaUrl";

const SeasonalContext = createContext(null);

export function SeasonalProvider({ children }) {
  const [seasonalGroups, setSeasonalGroups] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchSeasonalGroups = async () => {
    try {
      setLoading(true);
      const data = await seasonalService.getSeasonalGroups();

      setSeasonalGroups(
        Array.isArray(data)
          ? data.map((g) => ({
              name: g.name ?? "",
              categories: g.categories ?? "",
              image: withRusticMediaVersion(g.image ?? null),
            }))
          : []
      );
    } catch (err) {
      console.error("Error fetching seasonal groups:", err);
      setSeasonalGroups([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSeasonalGroups();
  }, []);

  return (
    <SeasonalContext.Provider
      value={{
        seasonalGroups,
        loading,
        refreshSeasonals: fetchSeasonalGroups,
      }}
    >
      {children}
    </SeasonalContext.Provider>
  );
}

export default SeasonalContext;
